export * from "./table.component";
